import styled from 'styled-components';
import { IToken, ThemeList } from 'store/ducks/globalTypes';
import ReactBrightLogo from 'assets/img/logo/ProgRisCom (7).png';
import { IThemeSelectorProps } from 'components/ThemeSelector/ThemeSelector';
import { variablesList } from 'constants/variablesList';
import { Button } from 'antd';
import {
  OverlayProps,
  SidebarProps,
  AreaTitleProps,
} from 'store/ducks/Global/types';

export const LeftZone = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 0;
`;

export const CenterZone = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: start;
  min-width: 0;
  padding-top: 4px;

  @media (max-width: 991px) {
    flex: 0 0 100%;
    order: 2;
    padding-top: 0;
    justify-content: flex-start;
    padding-left: 8px;
    margin-top: -20px;
  }

  @media (max-width: 768px) {
    margin-top: -35px;
  }

  @media (max-width: 375px) {
    justify-content: flex-start;
  }
`;

export const RightZone = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: start;
  gap: 12px;
  justify-content: flex-end;
  min-width: 0;
  padding-top: 4px;
  flex-shrink: 0;
  margin-left: auto;

  @media (max-width: 991px) {
    order: 1;
    padding-top: 0;
  }
`;

export const MobileButtonsRow = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0px 24px;
    justify-content: center;
  }

  @media (max-width: 425px) {
    margin-top: 10px;
  }
`;

export const MobileNavButtonsRow = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
  }
`;

export const StyledNav = styled('div')<IToken>`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 12px;
  padding: ${(props) => `8px ${props.token.paddingLG}px 0`};

  @media (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export const StyledLogo = styled.img`
  width: 150px;
  position: relative;
  top: -40px;

  @media (max-width: 1640px) {
    width: 120px;
  }

  @media (max-width: 768px) {
    width: 88px;
    top: -18px;
  }
`;

export const logoSrc = ReactBrightLogo;

export const DropdownContainer = styled('div')`
  margin-top: 10px;
  flex-direction: column;
  display: flex;

  @media (max-width: 1640px) {
    margin-top: 0px;
    width: -webkit-fill-available;
  }
`;

export const ChangeButton = styled('div')`
  text-align: end;

  a {
    z-index: 1;
    color: black;
  }

  .ant-btn-variant-solid {
    margin: 0px 0px 0px 16px;

    @media (max-width: 768px) {
      max-width: 126px;
      margin: 0px 0px 0px 5px;
    }

    span {
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
`;

export const MainButtons = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 10px;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const Sidebar = styled.div<SidebarProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  transition: transform 0.3s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  z-index: 1000;
`;

export const Overlay = styled.div<OverlayProps>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
`;

export const SubtitleText = styled.p`
  font-size: 1rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.9);
  margin: 5px 0 0 0;
`;

export const AreaTitle = styled('div')<AreaTitleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-left: ${({ isShort }) => (isShort ? '15%' : '0')};

  @media (max-width: 991px) {
    margin-left: 0;
    margin: 5px auto;
  }
`;

export const TitleContainer = styled('div')<IThemeSelectorProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    307deg,
    ${(props) =>
        (
          variablesList[props.theme as unknown as ThemeList] ??
          variablesList['mainTheme']
        ).buttonPrimaryBgHover}
      84%,
    ${(props) =>
        (
          variablesList[props.theme as unknown as ThemeList] ??
          variablesList['mainTheme']
        ).tabSelected}
      95%
  );
  padding: 16px 32px;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  min-width: clamp(180px, 20vw, 320px);
  max-width: min(600px, 42vw);

  @media (max-width: 1640px) {
    padding: 10px 16px;
  }

  @media (max-width: 1200px) {
    min-width: unset;
    max-width: min(300px, 28vw);
    padding: 8px 12px;
  }

  @media (max-width: 375px) {
    padding: 6px 8px;
    min-width: unset;
    max-width: 110px;
    top: 10px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: -35px;
  }

  @media (max-width: 320px) {
    padding: 6px 10px;
    min-width: unset;
    top: 10px;
  }
`;

export const DataEntryTitle = styled.span`
  margin: 0;
  font-weight: bold;
  font-size: clamp(11px, 2vw, 32px);
  color: white;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
  line-height: 1.3;

  @media (max-width: 1200px) {
    font-size: clamp(11px, 1.4vw, 18px);
    word-break: break-word;
  }

  @media (max-width: 991px) {
    font-size: 14px;
    word-break: break-word;
    max-width: 120px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
    max-width: 100px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    max-width: 85px;
  }
`;

export const WorkingAreaButton = styled.div<{ token: any }>`
  display: flex;
  margin: 0 24px;
  justify-content: end;
  gap: 20px;
  position: relative;

  button {
    background: ${({ token }) => token.actionButtons};
    width: 193px;
    white-space: pre-wrap;

    &:hover {
      background-color: ${({ token }) => token.actionButtonsHover} !important;
    }
  }

  div {
    gap: 15px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const LogoutBtn = styled(Button)<{ token: any }>`
  background: ${({ token }) => token.logoutBtn};
  color: #fff;
  transition: background 0.3s ease;
  border: 1px solid ${({ token }) => token.logoutBtn} !important;
  padding: 3px;
  align-self: flex-start;

  &:hover {
    background: ${({ token }) => token.logoutBtnHover} !important;
    color: #fff !important;
    border: 1px solid ${({ token }) => token.logoutBtnHover} !important;
  }

  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

export const WorkingAreaButtonData = styled.div<{ token: any }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 24px;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  button {
    background: ${({ token }) => token.actionButtons};
    white-space: normal;
    padding: 3px;

    &:hover {
      background-color: ${({ token }) => token.actionButtonsHover} !important;
    }
  }
`;

export const ConsiderModalBtn = styled(Button)`
  z-index: 100;
`;

export const ModalContent = styled('div')`
  line-height: 1.6;
`;

export const DesktopButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 10px;

  @media (max-width: 991px) {
    display: none;
  }

  button,
  .ant-select {
    justify-content: center;
    padding: 4px 8px;
    min-height: 32px;
    height: auto;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.4;
    text-align: center;
  }
`;

export const NavButtonsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  align-self: center;
  margin-top: -90px;

  &:has(> :only-child) {
    margin-top: -135px;
  }

  @media (max-width: 1200px) {
    margin-top: 0;

    &:has(> :only-child) {
      margin-top: 0;
    }
  }

  @media (max-width: 1024px) {
    margin-top: -90px;

    &:has(> :only-child) {
      margin-top: -135px;
    }
  }

  a,
  button {
    width: 100%;
  }

  @media (max-width: 991px) {
    display: none;
  }
`;
